import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { IEnrollment, IPaymentItem } from '../../types';
import AdditionalInfoSection from './AdditionalInfoSection';
import EnrollmentIdsSection from './EnrollmentIdsSection';
import MonthlyPaymentSection from './MonthlyPaymentSection';
import PlanCardSection from './PlanCardSection';

const getPaymentItems = (enrollment: IEnrollment): IPaymentItem[] => [
    { labelId: 'member.enrollment_list.premiumhistory.premiumAmount', value: enrollment.monthlyPremium },
    { labelId: 'historical.member.applications.electedFederalAptcAmount', value: enrollment.electedAptc },
    { labelId: 'historical.member.applications.premiumAssistance', value: enrollment.electedStateSubsidy },
    { labelId: 'historical.member.applications.napa', value: enrollment.appliedStateSubsidy2 },
    { labelId: 'member.enrollment_list.premiumhistory.netPremium', value: enrollment.netPremium, isTotal: true },
];

interface IHistoricalEnrollmentsContentProps {
    enrollments: IEnrollment[];
}

const HistoricalEnrollmentsContent: React.FC<IHistoricalEnrollmentsContentProps> = ({ enrollments }) => {
    return (
        <>
            <ConditionalRendering isTrue={enrollments.length === 0}>
                <div className="text-center padding-y-5 text-base-dark">
                    <FormattedMessage id="historical.member.applications.noEnrollmentDataAvailable" />
                </div>
            </ConditionalRendering>

            <ConditionalRendering isTrue={enrollments.length > 0}>
                {enrollments.map((enrollment, index) => (
                    <div className="border-1px border-base-lighter radius-lg padding-3 margin-bottom-3" key={enrollment.policyId || index}>
                        <PlanCardSection
                            id={`enrollment-plan-card-section-cap-${index}`}
                            enrollment={enrollment}
                            labels={{
                                enrollmentStatusLabel: 'historical.member.applications.enrollmentStatus',
                                effectiveDateLabel: 'historical.member.applications.effectiveDate',
                            }}
                        />

                        <div className="padding-2 margin-bottom-3">
                            <div className="grid-row grid-gap-6">
                                <div className="grid-col-5 tablet:grid-col-6">
                                    <MonthlyPaymentSection
                                        id={`enrollment-monthly-payment-section-cap-${index}`}
                                        titleLabelId="member.enrollment_list.premiumhistory.monthlyPayment"
                                        paymentItems={getPaymentItems(enrollment)}
                                    />
                                </div>
                                <div className="grid-col-5 tablet:grid-col-6">
                                    <EnrollmentIdsSection enrollment={enrollment} />
                                </div>
                            </div>
                        </div>

                        <AdditionalInfoSection enrollment={enrollment} />
                    </div>
                ))}
            </ConditionalRendering>
        </>
    );
};

export default HistoricalEnrollmentsContent;
